import styled from "styled-components"

export const Container = styled.div`
  /* flex: 1; */
  height: 100%;
  background-color: red;
  .dates{
    font-size: .75rem;
    margin-bottom: 20px;
    display:block;
  }
`